import React, {
  useEffect,
  useState,
  // ChangeEvent,
} from 'react';

import { useTranslation } from 'react-i18next';
import Input from '@cashew/input';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmModal from '@cashew/confirm-modal';
import { Button } from '../../components';

import './OnboardingForm.css';
import { validateEmail } from '../../helpers/validations';
import ValidationModal from './ValidationModal';
import { StatusType } from '../CustomerDetail';
import {
  checkMerchantActivationStatus,
  getKycConfigAPI,
  resendWelcomeEmailAPI,
  updateEmailAPI,
  // updateKycConfigAPI,
} from './merchantApi';
import PaymentOptionList from './PaymentOption/PaymentOptionList';
import SelectComponent from '../../components/SelectComponent';

const { api } = require('@cashew/utils');

const formClassname = 'onboarding-form';
const ns = 'configurations';
const ConfigurationsSection = ({ merchantData }: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { token } = useSelector((state: any) => state.user);
  const [selectedStore, setSelectedStore] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [storeList, setStoreList] = useState([]);
  const [kycDocumentsCheck, setKycDocumentsCheck] = useState(false);
  const [kycFaceCheck, setKycFaceCheck] = useState(false);
  const [emailError, setEmailError] = useState('');

  const [updatedEmailLoading, setUpdatedEmailLoading] = useState(false);
  const [emailUpdateStatus, setEmailUpdateStatus] =
    useState<StatusType>('none');
  const [showUpdateEmailModal, setShowUpdateEmailModal] = useState(false);
  const [welcomeEmailLoading, setWelcomeEmailLoading] = useState(false);
  const [showWelcomeConfirmModal, setShowWelcomeConfirmModal] = useState(false);
  const [merchantActivationStatus, setMerchantActivationStatus] = useState('');

  useEffect(() => {
    setEmailAddress(merchantData?.email);
  }, [merchantData]);
  useEffect(() => {
    if (!merchantData?.id) {
      return;
    }

    checkMerchantActivationStatus({
      merchantId: merchantData.id,
      token,
      setMerchantActivationStatus,
    });
    api
      .get({
        endpoint: 'stores',
        headers: {
          Authorization: token,
        },
        params: {
          merchantId: merchantData.id,
        },
      })
      .then((resp: any) => {
        const listStores = resp.data.map((item: any) => ({
          key: item.id,
          value: item.storeName,
        }));

        listStores.sort((firstElement: any, secondElement: any) => {
          const firstElementValue = firstElement.value.toUpperCase();
          const secondElementValue = secondElement.value.toUpperCase();
          // eslint-disable-next-line no-nested-ternary
          return firstElementValue === secondElementValue
            ? 0
            : firstElementValue > secondElementValue
              ? 1
              : -1;
        });
        setStoreList(listStores);
      })
      .catch((resp: any) => {
        console.log(resp);
      });
  }, [merchantData]);

  const updateEmail = () => {
    updateEmailAPI({
      merchantId: merchantData?.id,
      emailAddress: merchantData?.email,
      newValue: emailAddress,
      token,
      dispatch,
      t,
      setEmailUpdateStatus,
      setShowUpdateEmailModal,
      setUpdatedEmailLoading,
    });
  };

  useEffect(() => {
    if (!selectedStore) {
      return;
    }
    getKycConfigAPI({
      storeId: selectedStore,
      token,
      setKycDocumentsCheck,
      setKycFaceCheck,
    });
  }, [selectedStore]);
  useEffect(() => {
    if (!kycDocumentsCheck) {
      setKycFaceCheck(false);
    }
  }, [kycDocumentsCheck]);
  return (
    <div>
      <div className={ns}>
        <div className={`${formClassname}__line`}>
          <strong className={`${formClassname}__label-text`}>
            Manage email address
          </strong>
        </div>
        <div className={`${formClassname}__line`}>
          <div>
            <Input
              placeholder={t('merchantOnboarding.merchant.field.emailAddress')}
              name="email"
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              onBlur={() => {
                setEmailError(
                  !validateEmail(emailAddress) && emailAddress !== ''
                    ? t('customerDetails.emailValidationError')
                    : ''
                );
              }}
              error={emailError}
            />
          </div>
          <div>
            <Button
              extraClass={`${ns}__save-button`}
              disabled={
                merchantData?.email === emailAddress ||
                !validateEmail(emailAddress) ||
                updatedEmailLoading
              }
              onClick={() => {
                updateEmail();
              }}
              loading={updatedEmailLoading}
            >
              Save
            </Button>
          </div>
        </div>
        <div className={`${formClassname}__line`}>
          <div>
            <Button
              extraClass={`${ns}__save-button ${ns}__resend-button`}
              disabled={
                welcomeEmailLoading || merchantActivationStatus === 'ACTIVE'
              }
              loading={welcomeEmailLoading}
              onClick={() => {
                resendWelcomeEmailAPI({
                  token,
                  merchantId: merchantData?.id,
                  dispatch,
                  t,
                  setWelcomeEmailLoading,
                  setShowWelcomeConfirmModal,
                });
              }}
            >
              Resend welcome email
            </Button>
          </div>
        </div>

        <div className={`${formClassname}__separator`} />
        <div className={`${formClassname}__line`}>
          <strong className={`${formClassname}__label-text`}>
            Manage store payment & KYC options
          </strong>
        </div>
        <div className={`${formClassname}__line`}>
          <div>
            <SelectComponent
              data={storeList}
              label="Select a store"
              selected={selectedStore}
              onSelect={setSelectedStore}
            />
          </div>
          <div />
        </div>
        {selectedStore && (
          <>
            <div className={`${formClassname}__line`}>
              <strong className={`${formClassname}__label-text`}>
                Store KYC options
              </strong>
            </div>
            <div className={`${formClassname}__line`}>
              <div className="kyc-check">
                <Input
                  type="checkbox"
                  id="kycDocumentsCheck"
                  name="kycDocumentsCheck"
                  checked={kycDocumentsCheck}
                  label="KYC documents check"
                  // onChange={(e: ChangeEvent<HTMLInputElement>) => setKycDocumentsCheck(e.target.checked)}
                />
                <Input
                  type="checkbox"
                  id="kycFaceCheck"
                  name="kycFaceCheck"
                  checked={kycFaceCheck}
                  // readonly
                  label="KYC Face recognition"
                  // onChange={(e: ChangeEvent<HTMLInputElement>) => setKycFaceCheck(e.target.checked)}
                />
              </div>
              <div>
                {/* <Button */}
                {/*   extraClass={`${ns}__save-button`} */}
                {/*   disabled={!selectedStore} */}
                {/*   onClick={() => { */}
                {/*     updateKycConfigAPI({ */}
                {/*       storeId: selectedStore, token, kycEnabled: kycDocumentsCheck, faceRecognitionEnabled: kycFaceCheck, dispatch, */}
                {/*     }); */}
                {/*   }} */}
                {/* > */}
                {/*   Save */}
                {/* </Button> */}
              </div>
            </div>

            <PaymentOptionList storeId={selectedStore} />
          </>
        )}
        <ValidationModal
          status={emailUpdateStatus}
          type="email"
          updatedValue={emailAddress}
          resendLink={updateEmail}
          updateStatus={setEmailUpdateStatus}
          showModal={showUpdateEmailModal}
          setShowModal={setShowUpdateEmailModal}
        />
        <ConfirmModal
          isVisible={showWelcomeConfirmModal}
          onClose={() => {
            setShowWelcomeConfirmModal(false);
          }}
          showCloseButton={false}
          confirmTitle="Success"
          confirmDescription="Welcome email was send successfully"
          confirmButtons={<></>}
          resultTitle="Success"
          resultDescription="Welcome email was send successfully"
          resultButtons={
            <div>
              <Button
                extraClass="blue"
                onClick={() => {
                  setShowWelcomeConfirmModal(false);
                }}
              >
                Ok
              </Button>
            </div>
          }
          showResult
          resultStatus="success"
        />
      </div>
    </div>
  );
};

export default ConfigurationsSection;
